export default __webpack_public_path__ + "static/contribution-mobile-banner-7031c730f9bafcf320f6aa322a81faeb.png";